import axiosRestaurantInstance from './AxiosRestaurantInstance';

function authHeaders() {
    const token = localStorage.getItem('Token');
    return token ? { Authorization: `Bearer ${token}` } : {};
}

export function isCateringItemAvailable(item) {
    const v = item?.isAvailable ?? item?.Is_Available ?? item?.Is_available ?? item?.is_available;
    if (v === true || v === 1 || v === '1') return true;
    if (v === false || v === 0 || v === '0') return false;
    return true;
}

/**
 * Load a restaurant's catering menu items as flat rows shaped for the menu-template
 * picker. The catering id is exposed both as Catering_Item_Id (used to build the
 * template payload) and as Food_Item_Id (reused only for UI selection keying).
 * GET /catering/menu/:restaurantId
 */
export async function fetchCateringMenuItemsForTemplate(restaurantId) {
    if (!restaurantId) return [];
    const response = await axiosRestaurantInstance.get(
        `/catering/menu/${restaurantId}`,
        { headers: authHeaders() }
    );
    const data = response.data || {};
    const items = Array.isArray(data.items)
        ? data.items
        : data.cateringItemId != null
          ? [data]
          : Object.values(data).flat();

    return (Array.isArray(items) ? items : [])
        .map((item) => {
            const cateringItemId =
                item.cateringItemId ?? item.Catering_Item_Id ?? item.Food_Item_Id ?? null;
            if (cateringItemId == null) return null;
            const categoryName =
                item.foodCategory ??
                item.foodCategoryName ??
                item.Food_Category ??
                '';
            return {
                Catering_Item_Id: cateringItemId,
                Food_Item_Id: cateringItemId,
                Food_Item: item.itemName ?? item.Item_Name ?? item.item_name ?? item.Food_Item ?? '',
                foodCategoryId: item.foodCategoryId ?? item.food_category_id,
                Food_Category: categoryName,
                itemFoodType: item.foodType ?? item.itemFoodType ?? 'VEG',
                Price: item.price ?? item.Price ?? '',
                imageUrl: item.imageUrl ?? item.imagePath ?? item.Image_Path ?? null,
                isAvailable: item.isAvailable ?? item.Is_Available ?? item.is_available ?? true,
            };
        })
        .filter(Boolean)
        .filter(isCateringItemAvailable);
}
